<template>
    <v-dialog
        :value="isOpen"
        max-width="700px"
        transition="slide-y-transition"
        eager
        @keydown.esc="onClose"
        @click:outside="onClose"
    >
        <v-card>
            <v-card-title>
                <h1 class="text-subtitle-1">
                    Dodaj nową etykietę
                </h1>
            </v-card-title>
            <v-card-text>
                <v-container>
                    <v-row>
                        <v-col cols="12" sm="12" md="12">
                            <v-text-field
                                v-model="itemData.shopFormat"
                                label="format sklepu"
                                :rules="withTrimRules"
                                @change="isTouch = true"
                            />
                        </v-col>
                        <v-col cols="4">
                            <v-text-field
                                v-model="itemData.shopIndex"
                                label="indeks"
                                :rules="indexRules"
                                @change="isTouch = true"
                            />
                        </v-col>
                        <v-col cols="4">
                            <v-text-field
                                v-model="itemData.ean"
                                label="EAN"
                                :rules="eanRules"
                                @change="isTouch = true"
                            />
                        </v-col>
                        <v-col cols="4">
                            <v-text-field
                                v-model.number="itemData.copies"
                                v-mask="'####'"
                                type="number"
                                label="ilość"
                                :rules="copiesRules"
                                @change="isTouch = true"
                            />
                        </v-col>
                    </v-row>
                </v-container>
            </v-card-text>
            <v-divider />
            <v-card-actions>
                <v-btn
                    color="error"
                    text
                    data-sentry-label="Anuluj"
                    @click="onClose()"
                >
                    Anuluj
                </v-btn>
                <v-spacer />
                <v-btn
                    color="success"
                    text
                    data-sentry-label="Zapisz"
                    :disabled="!canSave"
                    @click="addLabelsToList()"
                >
                    Zapisz
                </v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>
import _ from 'lodash'
import { required, integer, minValue } from 'vuelidate/lib/validators'
import { isInteger } from '@/utils/customValidators'

export default {
    name: 'AddEditLabelsWithEANDialog',
    props: {
        item: {
            type: Object,
            default: () => {}
        },
        isOpen: {
            type: Boolean
        },
    },
    data() {
        return {
            itemData: {
                id: null,
                ean: null,
                shopIndex: null,
                shopFormat: null,
                copies: null
            },
            isTouch: false,
        }
    },
    validations: {
        itemData: {
            ean: {
                required,
                integer,
                minValue: minValue(0)
            },
            shopIndex: {
                required,
                integer,
                minValue: minValue(0)
            },
            shopFormat: {
                required
            },
            copies: {
                required,
                integer,
                minValue: minValue(0)
            },
        }
    },
    computed: {
        canSave() {
            return !this.$v.$invalid
        },
        indexRules() {
            return this.integerRules(this.itemData.shopIndex)
        },
        eanRules() {
            return this.integerRules(this.itemData.ean)
        },
        copiesRules() {
            return this.integerRules(this.itemData.copies)
        },
        withTrimRules() {
            if (!this.isTouch) return []
            if (
                (
                    typeof this.itemData.shopFormat == 'string' &&
                    this.itemData.shopFormat.trim() === ''
                ) ||
                this.itemData.shopFormat === null ||
                this.itemData.shopFormat === undefined
            ) {
                return ['To pole jest wymagane']
            }

            return []
        }
    },
    watch: {
        isOpen(value) {
            if (value) {
                this.itemData = {
                    id: this.item.id,
                    ean: this.item.ean,
                    shopIndex: this.item.shopIndex,
                    shopFormat: this.item.shopFormat?.trim(),
                    copies: this.item.copies || 0
                }
                this.isTouch = false
            }
        },
    },
    methods: { 
        onClose() {
            this.$emit('on-close')
            setTimeout(() => {
                this.itemData = {
                    id: null,
                    ean: null,
                    shopIndex: null,
                    shopFormat: null,
                    copies: null
                }
            }, 500)
        },
        addLabelsToList() {
            this.$v.$touch()

            if (!this.$v.$invalid) {
                this.$emit('on-save', this.itemData)
                this.onClose()
            }
        },
        integerRules(field) {
            const rules = []
        
            if (!this.isTouch) return []
            if (field === '' || field === null || field === undefined) {
                rules.push('To pole jest wymagane')
            } else if (
                !isInteger(field) || !_.inRange(field, 0, Infinity)
            ) {
                rules.push('Nieprawidłowy format')
            }
            
            return rules
        }
    }
}
</script>